import React from "react";
import Home from './components/Home.js';
import NavBar from "./components/NavBar";

function App() {
  return (
    <div>
      <NavBar/>
      <Home />
    </div>
  );
}

export default App;
